import React from "react";
import { Compass } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function OurEthicsAffiliateDisclosure() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="our-ethics-affiliate-disclosure" ref={ref} className={cn("dark bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 flex flex-col items-center justify-center text-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
      {}
      <div className="mb-8 text-foreground/90 animate-pulse duration-[3000ms]">
        <Compass className="w-10 h-10 md:w-12 md:h-12 stroke-[1.5]" />
      </div>

      {}
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif tracking-wider mb-16 uppercase text-foreground">
        Honesty is Our North Star.
      </h2>

      {}
      <div className="w-full max-w-2xl text-left mx-auto">
        <Accordion type="single" collapsible className="w-full">
          {}
          <AccordionItem value="item-1" className="border-b border-border/30">
            <AccordionTrigger className="text-lg md:text-xl font-sans font-medium hover:no-underline hover:text-primary transition-colors py-6 data-[state=open]:text-primary">
              How we test gear
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6 font-sans">
              We don&apos;t do &quot;box openings&quot; in a studio. Every piece
              of gear reviewed on Wildlings West Overland is tested in the
              field—specifically, the rugged terrain of the American West. From
              scorching deserts to high-altitude mountain passes, we put
              equipment through the wringer on real family overlanding trips. If
              it fails us, we tell you. If it survives our kids and the trail,
              we recommend it.
            </AccordionContent>
          </AccordionItem>

          {}
          <AccordionItem value="item-2" className="border-b border-border/30">
            <AccordionTrigger className="text-lg md:text-xl font-sans font-medium hover:no-underline hover:text-primary transition-colors py-6 data-[state=open]:text-primary">
              How we make money
            </AccordionTrigger>
            <AccordionContent className="text-muted-foreground text-base leading-relaxed pb-6 font-sans">
              Transparency is key. We participate in affiliate programs, which
              means if you click a link to a product we recommend and make a
              purchase, we may earn a small commission at no extra cost to you.
              This helps keep our rig running and our content free. We never
              accept payment in exchange for a positive review. Our opinions are
              100% our own, forged on the trail.
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </section>;
}